import { League } from "@/models";
import { PaginationResponse } from "../models/pagination.model";
import { SportEvent, SportEventStatusCode } from "../models/sport-events.model";
import { ApiResponse } from "./../models/api.model";
import axios from "./axios";

const ITEMS_PER_PAGE = 9;

export default {
  getEvents(page: number = 1, search: string = "", type?: SportEventStatusCode) {
    return axios.get().get<PaginationResponse<SportEvent[]>>(`/events`, {
      params: {
        search,
        type,
        page,
        per_page: ITEMS_PER_PAGE
      }
    });
  },
  getEvent(id: number) {
    return axios.get().get<ApiResponse<SportEvent>>(`/events/${id}`);
  },
  getEventLeagues(id: number) {
    return axios.get().get<ApiResponse<League[]>>(`/events/${id}/league`);
  }
};
